/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatedFileResultDto } from '../models/CreatedFileResultDto';
import type { DocumentGroupDto } from '../models/DocumentGroupDto';
import type { DocumentGroupsStatusResultDto } from '../models/DocumentGroupsStatusResultDto';
import type { DocumentMetaDto } from '../models/DocumentMetaDto';
import type { DocumentResponseDto } from '../models/DocumentResponseDto';
import type { FileInfoDto } from '../models/FileInfoDto';
import type { SendSMSesDto } from '../models/SendSMSesDto';
import type { UploadLinkRequestDto } from '../models/UploadLinkRequestDto';
import type { UploadLinkResultDto } from '../models/UploadLinkResultDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class DocumentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param groupName
     * @param initiator
     * @returns DocumentGroupDto Success
     * @throws ApiError
     */
    public getApiDocumentsGroups(
        groupName: string,
        initiator?: string,
    ): CancelablePromise<Array<DocumentGroupDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/groups/{groupName}',
            path: {
                'groupName': groupName,
            },
            query: {
                'initiator': initiator,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param initiator
     * @returns DocumentGroupDto Success
     * @throws ApiError
     */
    public getApiDocumentsGroups1(
        initiator?: string,
    ): CancelablePromise<Array<DocumentGroupDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/groups',
            query: {
                'initiator': initiator,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param initiator
     * @param uniqueDocumentsPerType
     * @returns DocumentResponseDto Success
     * @throws ApiError
     */
    public getApiDocuments(
        initiator?: string,
        uniqueDocumentsPerType?: boolean,
    ): CancelablePromise<Array<DocumentResponseDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents',
            query: {
                'initiator': initiator,
                'uniqueDocumentsPerType': uniqueDocumentsPerType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param meta
     * @param formData
     * @returns CreatedFileResultDto Success
     * @throws ApiError
     */
    public postApiDocuments(
        meta?: DocumentMetaDto,
        formData?: {
            file?: Blob;
        },
    ): CancelablePromise<CreatedFileResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/documents',
            query: {
                'meta': meta,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param id
     * @returns FileInfoDto Success
     * @throws ApiError
     */
    public getApiDocuments1(
        id: number,
    ): CancelablePromise<FileInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param id
     * @returns FileInfoDto Success
     * @throws ApiError
     */
    public deleteApiDocuments(
        id: number,
    ): CancelablePromise<FileInfoDto> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param id
     * @returns FileInfoDto Success
     * @throws ApiError
     */
    public getApiDocumentsFile(
        id: number,
    ): CancelablePromise<FileInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/{id}/file',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param id
     * @returns FileInfoDto Success
     * @throws ApiError
     */
    public getApiDocumentsPreview(
        id: number,
    ): CancelablePromise<FileInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/{id}/preview',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public postApiDocumentsValidatecustomer(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/documents/validatecustomer',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param id
     * @returns FileInfoDto Success
     * @throws ApiError
     */
    public getApiDocumentsThumbnail(
        id: number,
    ): CancelablePromise<FileInfoDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/{id}/thumbnail',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Accepted
     * @throws ApiError
     */
    public postApiDocumentsSmses(
        requestBody?: SendSMSesDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/documents/smses',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @deprecated
     * @param requestBody
     * @returns UploadLinkResultDto Success
     * @throws ApiError
     */
    public postApiDocumentsUploadlink(
        requestBody?: UploadLinkRequestDto,
    ): CancelablePromise<UploadLinkResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/documents/uploadlink',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param initiator
     * @returns DocumentGroupsStatusResultDto Success
     * @throws ApiError
     */
    public getApiDocumentsStatus(
        initiator?: string,
    ): CancelablePromise<DocumentGroupsStatusResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/status',
            query: {
                'initiator': initiator,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param verificationType
     * @param pixelPerModule
     * @returns string Success
     * @throws ApiError
     */
    public getApiDocumentsQrCode(
        verificationType?: string,
        pixelPerModule: number = 10,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/documents/qr-code',
            query: {
                'verificationType': verificationType,
                'pixelPerModule': pixelPerModule,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
}
